import classNames from "classnames";
import { useContext } from "react";
import { getLogo, getTemplateFile } from "../http/chapterApi";
import Download from "../icons/Download.svg?react";
import { FileType, ListItemData } from "../types/types";
import { getIcon } from "../utils";
import { DataContext } from "./AppRouter";
import styles from "./ListItem.module.css";
import Button from "./ui/Button";
import Icon from "./ui/Icon";

interface Props {
  file: string;
  isTemplates: boolean | undefined;
}

const downloadFile = async (
  chapterId: number | undefined,
  file: string,
  isTemplates: boolean | undefined,
) => {
  const blob = isTemplates
    ? await getTemplateFile(chapterId, file)
    : await getLogo(chapterId);
  const url = blob && window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url ?? "";
  link.setAttribute("download", file);
  document.body.appendChild(link);
  link.click();
};

const ListItem = ({ file, isTemplates }: Props) => {
  const dataSplit = file.split(".");
  const { chapter } = useContext(DataContext);

  const fileObject: ListItemData = {
    name: dataSplit[0] ?? "",
    extension: dataSplit[1] as FileType,
  };

  return (
    <tr className={classNames(styles.row, styles["row-grid-wide"])}>
      <td className={styles.label}>{fileObject.name}</td>
      <td className={classNames(styles.label, styles["file-type"])}>
        <Icon
          className={styles["file-icon"]}
          glyph={getIcon(fileObject.extension)}
        />
        {fileObject.extension}
      </td>
      <td>
        <Button
          buttonProps={{
            onClick: () => {
              downloadFile(chapter?.id, file, isTemplates);
            },
            className: styles["btn-download"],
          }}
        >
          <Icon className={styles["btn-icon"]} glyph={Download} />
          <span className={styles["btn-label"]}>Herunterladen</span>
        </Button>
      </td>
    </tr>
  );
};

export default ListItem;
